import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { IRRELEVANCE_UX_241017 } from "@faire/web-api--source/indigofair/settings/IRRELEVANCE_UX_241017";

export const useSettingSearchRelevanceUX = (): boolean =>
  useSetting(IRRELEVANCE_UX_241017, false);
